module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/babel-runtime/core-js/symbol.js
// module id = 1249
// module chunks = 3